import { useEffect, useState } from "react";
import { CoverageSourceLink } from "./CoverageSourceLink";
import type { FreqMapperCoverageState } from "./map/useFreqMapperCoverage";
import { FM_CLASSES, FM_EVIDENCE_LINE, FM_SOURCE_LINK, FM_IMPORTING_LINE, FM_MESHCORE_ONLY_MESSAGE, FM_ZOOM_IN_MESSAGE, footerLine } from "../lib/freqmapperCoverage";

// The body of the "FreqMapper coverage" legend panel (MapLegends.tsx wraps it in the folding panel): the colour key first (so it
// is the part a small panel always shows), one row per class in FreqMapper's own colours, this viewer's switch, the zoom hint
// below zoom 9, then how old the data is and whether the latest refresh worked, and a line saying blank does not mean no
// coverage. Under the MeshCore only filter the layer is off and the panel says so.
export function FreqMapperLegendBody({ fm }: { fm: FreqMapperCoverageState }) {
  const [nowMs, setNowMs] = useState(() => Date.now());
  useEffect(() => {
    const t = window.setInterval(() => setNowMs(Date.now()), 30_000);
    return () => window.clearInterval(t);
  }, []);
  const meta = fm.meta;
  const live = fm.layerOn && !fm.meshcoreOnly && meta?.has_data;
  return (
    <div className="legend mm-legend fm-legend">
      {live && (
        <div className="fm-key" role="list" aria-label="Colour key">
          {FM_CLASSES.map((c) => (
            <div className="legend-row fm-key-row" role="listitem" key={c.cls} title={c.text}>
              <span className="legend-swatch mm-band-swatch fm-swatch" style={{ background: c.fill, borderColor: c.outline }} />
              <span className="mm-key-label">{c.text}</span>
            </div>
          ))}
        </div>
      )}
      <CoverageSourceLink link={FM_SOURCE_LINK} />
      <label className="mm-legend-switch">
        <input type="checkbox" checked={fm.layerOn && !fm.meshcoreOnly} disabled={fm.meshcoreOnly} onChange={(e) => fm.setLayerOn(e.target.checked)} />
        <span>Show on the map</span>
      </label>
      {fm.meshcoreOnly && <div className="legend-row mm-zoom-hint">{FM_MESHCORE_ONLY_MESSAGE}</div>}
      {live && fm.zoomedOut && <div className="legend-row mm-zoom-hint">{FM_ZOOM_IN_MESSAGE}</div>}
      {live && meta && (
        <div className="legend-section">
          <div className="legend-row mm-legend-updated" data-refresh={meta.refresh_status ?? "ok"}>{footerLine(meta, nowMs)}</div>
          {meta.importing && <div className="legend-note">{FM_IMPORTING_LINE}</div>}
          <div className="legend-note">{FM_EVIDENCE_LINE}</div>
        </div>
      )}
      {fm.layerOn && !fm.meshcoreOnly && !meta?.has_data && meta?.message && <div className="legend-note">{meta.message}</div>}
    </div>
  );
}
